/**
 * A window in which Redo staff have paused a merchant's coverage. Shaped like
 * `merchantPaidEnabledDates`, start-inclusive and end-exclusive like the DB.
 *
 * Shipped to the client as a window rather than a decision, so a cached
 * payload starts and ends the pause at its exact instants. The cost is that
 * `date` defaults to the shopper's clock in the browser; checkout rates are
 * evaluated server side and are not exposed to it.
 */
export interface CoveragePausedDateRange {
  start: string | Date | null;
  end?: string | Date | null;
}

/** Every window the caller knows about, so the calculator picks, not the caller. */
export type CoveragePausedDates = CoveragePausedDateRange[];

export function isCoveragePausedAt(
  coveragePausedDates: CoveragePausedDates | null | undefined,
  date: Date = new Date(),
): boolean {
  return (coveragePausedDates ?? []).some(
    ({ start, end }) =>
      start != null &&
      new Date(start) <= date &&
      (end == null || date < new Date(end)),
  );
}
